import React from 'react';
import './Tarifs.scss';

/**
 * Page présentant la grille tarifaire et les informations utiles de paiement/remboursement.
 */
const Tarifs = () => {
  const pricingData = [
    {
      title: "Entretien d’anamnèse",
      duration: "50 minutes",
      price: "60 €",
      details: null
    },
    {
      title: "Évaluation de l’efficience intellectuelle (QI)",
      duration: "1h30 à 2h (évaluation) + 1h (restitution)",
      price: "315 €",
      details: null
    },
    {
      title: "Bilan neuropsychologique",
      duration: "1h30 à 3h (1 ou 2 séances) + 1h (restitution)",
      price: "300 € à 450 €",
      details: "Le contenu, la durée et le tarif du bilan sont adaptés à votre demande et aux fonctions cognitives à explorer."
    },
    {
      title: "Bilan neuropsychologique complet",
      subtitle: "(Évaluation de l’efficience intellectuelle + évaluation cognitive)",
      duration: "3h à 3h30 (1 ou 2 séances) + 1h (restitution)",
      price: "480 € à 510 €",
      details: "Le contenu, la durée et le tarif du bilan sont adaptés à votre demande et aux fonctions cognitives à explorer."
    },
    {
      title: "Psychothérapie",
      duration: "50 minutes",
      price: "60 €",
      details: null
    },
    {
      title: "Consultation de suivi",
      subtitle: "(Remédiation cognitive, accompagnement des aidants, psychoéducation)",
      duration: "50 minutes",
      price: "60 €",
      details: null
    }
  ];

  return (
    <div className="tarifs-page container">
      <header className="page-header">
        <h1>Tarifs & Informations</h1>
        <p className="subtitle">Transparence et modalités d'accompagnement</p>
      </header>

      {/* Grille Tarifaire */}
      <section className="pricing-grid">
        {pricingData.map((item, index) => (
          <div key={index} className="pricing-card">
            <div className="pricing-info">
              <h2>{item.title}</h2>
              {item.subtitle && <p className="pricing-subtitle">{item.subtitle}</p>}
              <span className="pricing-duration">⏱️ {item.duration}</span>
              {item.details && <p className="pricing-details">{item.details}</p>}
            </div>
            <div className="pricing-amount">
              <span>{item.price}</span>
            </div>
          </div>
        ))}
      </section>

      {/* Informations Utiles */}
      <section className="useful-info-section">
        <h2>Informations utiles</h2>

        <div className="info-cards-grid">
          <div className="info-card">
            <h3>📋 Compris dans les bilans</h3>
            <p>
              Pour les bilans neuropsychologiques, le tarif comprend la passation des tests, 
              l’analyse des résultats, la rédaction d’un compte-rendu détaillé et un entretien de restitution avec recommandations.
            </p>
          </div>

          <div className="info-card">
            <h3>💳 Paiements sur place acceptés</h3>
            <p>
              Chèques, espèces, carte bleue ou virements bancaires instantanées. 
              <br/>
              ‼️ Si vous souhaitez régler par <strong>virement bancaire instantané</strong>, je vous invite à me contacter <strong>au moins 48 heures avant</strong> la consultation. Je vous transmettrai mon RIB afin que vous puissiez enregistrer le bénéficiaire au préalable et effectuer le règlement sur place. 
            </p>
          </div>

          <div className="info-card">
            <h3>🏥 Remboursement & Mutuelle</h3>
            <p>
              Les prestations du neuropsychologue <strong>ne sont pas remboursées</strong> par la Sécurité Sociale. 
              Cependant, certaines mutuelles proposent le remboursement partiel d’actes non-conventionnés (un justificatif vous sera fourni).
            </p>
            <p className="sub-text">
              Dans certaines conditions, une demande de remboursement de frais exceptionnels peut également être faite auprès de la CPAM.
            </p>
          </div>

          <div className="info-card warning-card">
            <h3>⚠️ Politiques d'annulation</h3>
            <p>
              Si vous avez un empêchement, merci d’annuler vos rendez-vous <strong>au moins 48h à l’avance</strong> afin de libérer le créneau pour d'autres patients.
            </p>
            <p className="sub-text">
              Les annulations survenant moins de 48h à l’avance ainsi que les rendez-vous non-honorés pourront être facturés à hauteur de 50% du montant total, sauf en cas de situation exceptionnelle.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;